export default "__VITE_ASSET__269adf3f__"